import Stripe from "images/stripe.png";
import BannerImage from "images/banner.png";

function Banner() {
  return (
    <div className="banner-container">
      <img src={BannerImage} alt="bannerimage" className="banner-image"></img>
      <h1 className="overlay-text">NFT Marketplace</h1>
      <img src={Stripe} alt="stripe" className="stripe-img"></img>
    </div>
  );
}

export default Banner;
